import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { SseService } from './sse.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PumpService {

  constructor(private _zone: NgZone, private _sseService: SseService, private http: HttpClient) { }


  pumpdashboard(body) {
    return this.http.post(`getPumpData`,body);
  }
  getPumpIds(body){
    return this.http.post(`getPumpIdsArray`,body);
  }
  getPumpDataTile(body){
    return this.http.post(`getPumpDataTile`,body)
  }
  getSelectedPumpData(body){
    return this.http.post(`getSelectedPumpData`,body)
  }
  getPumpAlerts(body){
    return this.http.post(`getPumpAlerts`,body)
  }
  gatewayReport(body){
    return this.http.post(`pumpgatewayReport`,body)
  }
  savePumpData(data: any) {
    let payload = data;
   return this.http.post('addUpdatePump', payload)
}
getPumpData(roleid, userid, module) {
    return this.http.get(`getPumpData?roleid=${roleid}&userid=${userid}&module=${module}`);
 }
getPumpids(){
  return this.http.get('getPumpids');
}
getTransformerIds() {
    return this.http.get('getTransformerIds');
}
getPumpDetails(data: any) {
  let payload = data;
  return this.http.get(`getPumpDetails?pumpId=${data.pumpId}&deletedFlag=${data.deletedFlag}`);
}
deletePump(data: any) {
    let payload = data;
    return this.http.post('deletePump', payload);
}
alertReport(data: any) {
  let payload = data;
  return this.http.post('alertReport', payload);
}
}
